export const css = {
    root: '_2p8IB-Lq',
    title: '_14iwedOW',
    about: '_3SmkpJ-k',
    vizblock: '_2oVfCby2',
    legend: '_3fZbUe9b',
    scoreIcon: 'OtZh5FXa',
    targetIcon: '_1Q9QSnU9',
    ' _key': 'topic-progress/topic-progress'
};
export default css;
